<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Correos Extemporáneos</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="800px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Correo</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span v-show="!editingItem" class="headline">Nuevo</span>
            <span v-show="editingItem" class="headline">Editar</span>
          </v-card-title>
          <v-card-text>

            <v-text-field
              :form="form"
              label="Nombre"
              :error-messages="errors.collect('nombre')"
              v-model="form.nombre"
              name="nombre"
            ></v-text-field>

            <v-text-field
              :form="form"
              label="Cédula"
              type="number"
              :error-messages="errors.collect('cedula')"
              v-model="form.cedula"
              name="cedula"
            ></v-text-field>
            <v-text-field
              :form="form"
              label="Correo"
              type="email"
              :error-messages="errors.collect('correo')"
              v-model="form.correo"
              name="correo"
            ></v-text-field>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">{{
              $t("admissions.settings.form.cancel")
            }}</v-btn>
            <v-btn
              v-if="!editingItem"
              color="blue darken-1"
              flat
              @click="saveItem"
              >{{ $t("admissions.settings.form.save") }}</v-btn
            >
            <v-btn v-else color="blue darken-1" flat @click="updateItem">{{
              $t("admissions.settings.form.update")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="extemporaneous_emails"
      :loading="loadingTable"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <!-- <td class="text-xs-center">{{ props.item.id }}</td> -->
        <td class="text-xs-center">{{ props.item.nombre }}</td>
        <td class="text-xs-center">{{ props.item.cedula }}</td>
        <td class="text-xs-center">{{ props.item.correo }}</td>
        <td class="text-xs-center">{{ props.item.sent }}</td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="editItem(props.item.id)"
              slot="activator"
            >
              edit
            </v-icon>
            <span>{{ $t("admissions.settings.edit") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="deleteItem(props.item.id)"
              slot="activator"
            >
              delete
            </v-icon>
            <span>{{ $t("admissions.settings.delete") }}</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import Form from "vform";
export default {
  name: "admissions-items-list",
  data() {
    return {
      headers: [
        // { text: "Id", align: "center", value: "id" },
        { text: "Nombre", align: "center", value: "nombre" },
        { text: "Cédula", align: "center", value: "cedula" },
        { text: "Correo", align: "center", value: "correo" },
        { text: "Enviado", align: "center", value: "sent" },
        {
          text: this.$t("admissions.settings.form.actions"),
          align: "center",
          value: "actions",
          sortable: false
        }
      ],
      extemporaneous_emails: [],
      // score_columns: [],
      isLoading: false,
      loadingTable: false,
      dialog: false,
      form: new Form({
        nombre: "",
        cedula: 0,
        correo: "",
      }),
      showSucessMessage: false,
      editingItem: false
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.getItems();
  },
  computed: {
  },
  methods: {
    async getItems() {
      this.loadingTable = true;
      let { data } = await axios.get("/api/admissions/extemporaneous_emails");
      this.extemporaneous_emails = data.items;
      this.score_columns = data.columns;
      this.loadingTable = false;
    },
    close() {
      (this.form = new Form({
        nombre: "",
        cedula: 0,
        correo: "",
      })),
        (this.dialog = false);
      this.editingItem = false;
    },
    // addCondition() {
    //   this.form.condition.push({column: null, score: 0});
    // },
    async saveItem() {
      if (await this.formHasErrors()) return;

      const result = await this.form.post(
        "/api/admissions/extemporaneous_emails",
        this.form
      );

      if (result.status === 200) {
        this.getItems();
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: this.$t("admissions.settings.messages.saved_ok"),
          modal: false
        });
      }

      this.close();
    },
    editItem(id_item) {
      const ItemToEdit = this.extemporaneous_emails.filter(
        type => type.id === id_item
      )[0];
      this.editingItem = true;
      this.dialog = true;
      this.form = new Form({
        id: ItemToEdit.id,
        grade: ItemToEdit.grade,
        initial_date_birth:ItemToEdit.initial_date_birth,
        final_date_birth:ItemToEdit.final_date_birth,
      });
    },
    deleteItem(id_item) {
      if (confirm("¿Está seguro de que quiere eliminar esta entrada?")) {
        axios
          .delete(`/api/admissions/extemporaneous_emails/${id_item}`)
          .then(resp => {
            if (resp.status === 200) {
              this.getItems();
            }
          })
          .catch(error => console.log(error));
      }
    },
    updateItem() {
      this.form
        .put("/api/admissions/extemporaneous_emails")
        .then(resp => {
          if (resp.status === 200) {
            this.getItems();
            this.close();
            this.editingItem = false;
          }
        })
        .catch(error => console.log(error));
    }
    // onlyNumbers($event) {
    //     let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
    //     if(keyCode == 45) { //This is a code por - (minus sign)
    //         $event.preventDefault();
    //     }
    // },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/extemporaneous_emails.vue